import { Text } from "@mantine/core";

const ReputationCell = ({ value }) => {
  return <Text c={value ? "green.8" : "black"}>{value || "-"}</Text>;
};

export default ReputationCell;
